export default "__VITE_ASSET__DgDeP0GV__"